import { ApiFetcher } from "./ApiFetcher";

interface DocUrlResponse {
  url: string;
  filename: string;
}

class DocsFetch {
  async download(filename: string): Promise<void> {
    const { data } = await new ApiFetcher().callApi<DocUrlResponse>({
      endpoint: `docs/${encodeURIComponent(filename)}`,
    });

    if (!data?.url) {
      throw new Error("No s'ha pogut obtenir l'URL de descàrrega");
    }

    const a = document.createElement("a");
    a.href = data.url;
    a.download = data.filename ?? filename;
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

const docsFetcher = new DocsFetch();
export default docsFetcher;
